<section class="w-full">
    <split-header-section
      title="Relatório Receitas"
    ></split-header-section>
    
    <form [style.padding-left]="'16.002px'"
    [style.padding-right]="'16.002px'" class="w-full ">
      <div class="grid">
        <div class="col-4 ">
          <div class="p-6 h-13rem bg-white border-round-2xl box-shadow cursor-pointer card-container" (click)="openModalReceitas()"
          pRipple
          >
            <div class="w-full header flex justify-content-between">
                <span class="title"> Pesquisar receitas </span> 
            </div>
            <div class="w-full mt-3">
                <span class="subtitle text-base "> Veja os relatórios das últimas receitas que você cadastrou  </span>
            </div>
          </div>
        </div>
        <div class="col-4  ">
          <div class="p-6 h-13rem bg-white border-round-2xl box-shadow cursor-pointer card-container"
          pRipple  [routerLink]="'/relatorios/financeiro/despesa'"
          >
            <div class="header flex justify-content-between w-full">
                <span class="title"> Despesas </span> 
            </div>
            <div class="w-full mt-3">
                <span class="subtitle text-base"> Veja os relatórios das últimas despesas que você cadastrou  </span>
            </div>
          </div>
        </div>
        <div class="col-4 ">
          <div class="p-6 h-13rem bg-white  border-round-2xl box-shadow cursor-pointer card-container"
          pRipple  [routerLink]="'/relatorios/financeiro'"
          >
              <div class="header flex justify-content-between w-full">
                  <span class="title"> Relatório financeiro </span> 
              </div>
              <div class="w-full mt-3">
                  <span class="subtitle text-base"> Veja os seus últimos relatórios financeiros </span>
              </div>
            </div>
          </div>
      </div>

      <div class="grid mt-2">
        <div  class="col">
            <split-card theme="secondary">
              <ng-container card-header>
                <div class="flex justify-content-between align-items-center">
                  <split-text
                    theme="secondery" 
                    title="Receitas" 
                    subtitle="Últimos 12 meses">
                  </split-text>
                  <div class="flex justify-content-between">
                    <split-group-filter id="monthToMonth" (onFilterEvent)="onFilterMonthToMonth($event)" class="mr-3">
                      <split-filter-month groupId="monthToMonth" view="year" field="year" key="year" label="Ano"></split-filter-month>
                      <split-filter-unit groupId="monthToMonth" field="unit" key="unit" label="Unidade"></split-filter-unit>
                    </split-group-filter>
                  </div>
                </div>
              </ng-container>
              <ng-container card-body>
                <div class="w-full">
                  <div class="valores_mes flex mb-4">
                      <div class="mes_atual flex flex-column align-items-start pr-3">
                        {{monthToMonthData.current | currency:'BRL':'symbol':'1.2-2' }}
                        <span class="subtitle"> Lucro mês atual </span>
                      </div>
                      <div
                        class=" border-pipe mes_anterior flex flex-column align-items-start justify-content-center pl-3"
                      >
                      {{monthToMonthData.previous | currency:'BRL':'symbol':'1.2-2' }}
                        <span class="subtitle"> Lucro mês anterior </span>
                      </div>
                    </div>
                    <split-line [highlightLastLabel]="true" [data]="monthToMonthData.data" [labels]="monthToMonthData.labels"></split-line>
                </div>
              </ng-container>
          </split-card>
        </div>
        <div  class="col">
          <div [style.height]="'35rem'" class="bg-white p-5 border-round-2xl box-shadow">
            <div class="header mb-5 flex justify-content-between">
              <div>
                <span class="title"> Receitas ano a ano </span>
              </div>
              <div>
                <split-group-filter id="resultReport" (onFilterEvent)="onFilterYearToYear($event)">
                  <split-filter-unit groupId="resultReport" field="unit" key="unit" label="Unidade"></split-filter-unit>
                </split-group-filter>
              </div>
            </div>  
            <div class="w-full">
              <div class="valores_mes flex mb-4">
                <div class="mes_atual flex flex-column align-items-start pr-3" style="color: #FF8321">
                  {{yearToYearData.current | currency:'BRL':'symbol':'1.2-2' }} 
                  <span class="subtitle"> Ano atual </span>
                </div>
              </div>
              <split-bar [disableCurrency]="true" [data]="yearToYearData.data" [columns]="yearToYearData.columns" color="#FF8321" ></split-bar>
            </div>
          </div>
        </div>
      </div>

      <div class="grid mt-2">
        <div class="col">
          <div class="bg-white p-5 border-round-2xl box-shadow">
            <div class="header mb-7 flex justify-content-between">
              <div>
                <span class="title"> Tipos de receitas </span> <br />
                <span class="subtitle">
                Últimos 12 meses </span>
              </div>
              <div class="flex align-items-center">
                <div class="flex align-items-center mr-4"></div>
              </div>
            </div>

            <div class="w-full">
              <split-line [allowLegend]="true" [data]="graphReportTypesOfRevenue.data" [labels]="graphReportTypesOfRevenue.labels"></split-line>
            </div>
          </div>
        </div>
        <div class="col-12 md:col-8 xl:col-4 resultado_anual"> 
          <div class="bg-white p-5 border-round-2xl box-shadow">
            <div class="header mb-5 flex justify-content-between">
              <div class="w-full">
                <div class="flex align-items-start mb-4 justify-content-between">
                  <div>
                    <span class="title"> Receitas anuais </span>
                  </div>
                  <p-button icon="pi pi-download" class="justify-self-end" severity="secondary" [rounded]="true" [text]="true" (onClick)="downloadAnnualRevenue()"></p-button>
                </div>
                
                  <div class="w-full flex justify-content-end">
                    <split-group-filter id="revenueReport" (onFilterEvent)="onFilterAnnualRevenue($event)">
                      <split-filter-unit groupId="revenueReport" field="unit" key="unit" label="Unidade"></split-filter-unit>
                    </split-group-filter>
                  </div>
                
                <br/>
                <split-report-message-year-month class="mb-3" *ngFor="let result of graphAnual"
                [class]="'green-card'"
                [year]="result.ano"
                [label]="'Faturamento total'"
                [percentage]="0"
                [columns]="[{valor: result.value.profit,descricao: 'Lucro'}]"
              ></split-report-message-year-month>
              </div>
            </div>
          </div>  
        </div>
      </div>
      <div class="grid mt-2">
        <div class="col">
          <split-results-per-month
          header="Resultados mês a mês"
          [columns]="receiptMonthly"
          [results]="true">
          <!--<split-group-filter id="monthMov" (onFilterEvent)="onMonthMovReport($event)" class="mr-3">
            <split-filter-month groupId="monthMov" view="year" field="year" key="year" label="Ano"></split-filter-month>
            <split-filter-dropdown groupId="monthMov" field="result" label="Resultado" [data]="resultData" key="result"></split-filter-dropdown>
            <split-filter-unit groupId="monthMov" field="unit" key="unit" label="Unidade"></split-filter-unit>
          </split-group-filter>
          <div>
            <div (click)="downloadResultadoMesAMes()"  pRipple class="cursor-pointer">                  
              <split-icon  size="19" name="arrow-bar-to-down" style="color: var(--secondary-color)"></split-icon>
            </div>
          </div>-->
        </split-results-per-month>
          <!--<split-results-per-month [receipts]="true" [disableResultado]="true" header="Receitas mês a mês" [columns]="form.value.receita_mes_a_mes"></split-results-per-month>-->
        </div>
      </div>      
    </form>
  </section>
  